const BaseComponent = require('base/base-component');
const Util = require('helper/util');
const Query = require('helper/query');

class UnivHeader extends BaseComponent {
  constructor () {
    super({
      events: {
        'input .mainkeyword': 'shapeShow',
        'click .icon-Shape': 'emptyInput'
      }
    });
  }
  init () {
    const that = this;
    this.query = new Query();
    this.$input = this.$el.find('.mainkeyword');
    if (!Util.isIE(8)) {
      that.$el.find('.js-head-menu').lavalamp({
        easing: 'easeOutBack'
      });
    }
    // 搜索框回填
    const keyword = this.query.get('k');
    if (keyword) {
      this.$input.val(keyword);
      this.$input.trigger('input');
    }
    // 搜索事件绑定
    if (this.$el.find('.logo-container .title').text().trim() === '搜索平台') {
      this.bindSearchEvent();
    } else {
      this.bindLinkEvent();
    }
  }

  bindLinkEvent () {
    this.$el.find('.mainkeyword').on('keydown', e => this.linkEvent(e));
    this.$el.find('.Jsearch').on('click', e => this.linkEvent(e));
  }
  bindSearchEvent () {
    this.$el.find('.mainkeyword').on('keydown', e => this.searchEvent(e));
    this.$el.find('.Jsearch').on('click', e => this.searchEvent(e));
  }

  searchEvent (e) {
    let keyword = this.$input.val();
    if (e.type === 'click') {
      $(window).trigger('fulltextSearch.ZCY', keyword);
    } else if (e.type == 'keydown' && e.keyCode == 13) {
      $(window).trigger('fulltextSearch.ZCY', keyword);
    }
  }

  linkEvent (e) {
    let keyword = this.$input.val();
    if (e.type === 'click') {
      location.href = `/full/search.html?k=${encodeURIComponent(keyword)}`;
    } else if (e.type == 'keydown') {
      e.keyCode == 13 && (location.href = `/full/search.html?m=0&k=${encodeURIComponent(keyword)}`);
    }
  }

  emptyInput (e) {
    this.$input.val('');
    $(e.target).hide();
    if (this.$el.find('.logo-container .title').text().trim() === '搜索平台') {
      $(window).trigger('fulltextSearch.ZCY', '');
    }
  }

  shapeShow (e) {
    const $ele = $(e.target || e.srcElement);
    if ($ele.val().length > 0) {
      this.$el.find('.icon-Shape').show();
    } else {
      this.$el.find('.icon-Shape').hide();
    }
  }
}
module.exports = UnivHeader;
